
export type YearMap = Record<string, string>;               // e.g. { "2024": "/geojson/SC47_2024.geojson", "2025": "/geojson/SC47_2025.geojson" }
export type DegradedEntry = string | YearMap;
export type DegradedMap = Record<string, DegradedEntry>;

export const LandCoverGeoJSON: DegradedMap = {
  CC13:{
    "2025": "/geojson/CC13.geojson"
  /*"2026": "/geojson/CC13.geojson*/}, 
  CC23:{"2025": "/geojson/CC23.geojson"},  // Added leading slash
  CC60: {"2025":"/geojson/CC60.geojson"},  // Added leading slash
  CC65: {"202":"/geojson/CC65.geojson"},  // Added leading slash
  CC63: {"2025":"/geojson/CC63.geojson"},  // Added leading slash
  SC11: {"2025":"/geojson/SC11.geojson"},  // Added leading slash
  SC28: {"2025":"/geojson/SC28.geojson"},  // Added leading slash
  SC30: {"2025":"/geojson/SC30.geojson"},  // Added leading slash
  SC3: {"2025":"/geojson/SC3.geojson"},    // Added leading slash
  SC35: {"2025":"/geojson/SC35.geojson"},  // Added leading slash
  SC47: {"2025":"/geojson/SC47.geojson"},  // Added leading slash
  SC41: {"2025":"/geojson/SC41.geojson"},  // Added leading slash
  SC48: {"2025":"/geojson/SC48.geojson"},  // Added leading slash
  SC52: {"2025":"/geojson/SC52.geojson"},  // Added leading slash
  SC5: {"2025":"/geojson/SC5.geojson"},    // Added leading slash
};